export class LoginCredential {
    constructor(   
        public Email?: string,
        public Password?: string
    ) {}
}